import styled from 'styled-components';

export const WbFallback = () => {
  return (
    <SWbFallback>
      <img src="https://s3.us-west-2.amazonaws.com/media.xiqonline.com/salesApp/images/xiqSpinner.gif" />
    </SWbFallback>
  );
};

const SWbFallback = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;